import * as _ from 'lodash';
import {Unit} from '../../../common/unit.model';

export const sortUnits = (units: Unit[]): Unit[] => {
  return _.sortBy(units, [
    (unit) => !unit.active, // Prioritize active units
    (unit) => new Date(unit.createdTimestamp).getTime(), // Sort by timestamp
    (unit) => unit.unitName // Sort by unit name if timestamps are equal
  ]);
};
